import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { httpinstance } from '../../axios/api';


// Async thunk for fetching customer contacts
export const getCustomerContacts = createAsyncThunk(
    'getCustomerContacts',
    async (value, { rejectWithValue }) => {
        try {
            const response = await httpinstance.get(`/customer-contact${value}`);
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);
// Async thunk for fetching customer contacts
export const getwhatsappgroups = createAsyncThunk(
    'getwhatsappgroups',
    async (value, { rejectWithValue }) => {
        try {
            const response = await httpinstance.get(`/admin/whatsapp-group`);
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

// Async thunk for creating a new customer contact
export const createCustomerContact = createAsyncThunk(
    'createCustomerContact',
    async (data, { rejectWithValue }) => {
        try {
            const response = await httpinstance.post('/customer-contact', data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

// Async thunk for updating a customer contact
export const updateCustomerContact = createAsyncThunk(
    'updateCustomerContact',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await httpinstance.patch(`/customer-contact/update-contact/${id}`, data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

// Async thunk for deleting a customer contact
export const deleteCustomerContact = createAsyncThunk(
    'deleteCustomerContact',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await httpinstance.patch(`/customer-contact/delete-contact/${id}`,data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

const initialState = {
    loading: false,
    contacts: [],
    error: '',
};

const customerContactsSlice = createSlice({
    name: 'customerContacts',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCustomerContacts.pending, (state) => {
                state.loading = true;
            })
            .addCase(getCustomerContacts.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.contacts = payload;
            })
            .addCase(getCustomerContacts.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            })
            .addCase(createCustomerContact.fulfilled, (state, { payload }) => {
                state.contacts.push(payload);
            })
            .addCase(createCustomerContact.rejected, (state, { payload }) => {
                state.error = payload;
            })
            .addCase(updateCustomerContact.fulfilled, (state, { payload }) => {
                state.contacts = state.contacts.map(contact => 
                    contact._id === payload._id ? payload : contact
                );
            })
            .addCase(updateCustomerContact.rejected, (state, { payload }) => {
                state.error = payload;
            })
            .addCase(deleteCustomerContact.fulfilled, (state, { payload }) => {
                state.contacts = state.contacts.filter(contact => contact._id !== payload._id);
            })
            .addCase(deleteCustomerContact.rejected, (state, { payload }) => {
                state.error = payload;
            });
    },
});

export default customerContactsSlice.reducer;
